import { render } from "./HotelInfo.vue?vue&type=template&id=86160cc2&scoped=true"
import script from "./HotelInfo.vue?vue&type=script&lang=js"
export * from "./HotelInfo.vue?vue&type=script&lang=js"

import "./HotelInfo.vue?vue&type=style&index=0&id=86160cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86160cc2"]])

export default __exports__